const HEADER_HEIGHT = 76;
const SCROLL_DURATION_S = 1.4;

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -HEADER_HEIGHT, duration: SCROLL_DURATION_S });
  else el.scrollIntoView({ behavior: "smooth" });
};
